import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getEnabledCampList, getEnabledTermList, getUserList, getEnabledColumnList, removeStudent, changeStudentCourse } from '@/api/student';
import { updateCourseCount } from '@/api/users';
import { mixin_export } from '@/utils/exportFile';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.search = {
            type: '-1',
            courseId: '',
            keywordType: '1',
            keyword: '',
            status: '-1',
        };
        this.props = {
            lazy: true,
            lazyLoad: async (node, resolve) => {
                const { level } = node;
                if (level <= 1) {
                    let nodes = level == 0 ? await this.getCampList() : await this.getTermList(node.value);
                    resolve(nodes);
                }
                else {
                    resolve([]);
                }
            }
        };
        this.tableData = [];
        this.pageNo = 1;
        this.pageSize = 15;
        this.total = 0;
        this.columnList = [];
        this.isShowAdd = false;
        this.form = {
            type: '',
            courseName: '',
            courseId: '',
            userId: '',
            id: ''
        };
    }
    created() {
        this.getColumnList();
        this.getList();
    }
    onSearch() {
        this.pageNo = 1;
        this.getList();
    }
    async getCampList() {
        let res = await getEnabledCampList();
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        let list = [];
        res.data.data.map((item) => {
            list.push({
                label: item.title,
                value: item.id,
                leaf: false,
            });
        });
        return list;
    }
    async getTermList(id) {
        let res = await getEnabledTermList(id);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        let list = [];
        res.data.data.map((item) => {
            list.push({
                label: item.name,
                value: item.id,
                leaf: true,
            });
        });
        return list;
    }
    async getColumnList() {
        let res = await getEnabledColumnList();
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.columnList = res.data.data || [];
    }
    async getList() {
        let data = {
            type: this.search.type,
            courseId: this.search.type == 2 ? this.search.courseId[1] : this.search.courseId,
            keywordType: this.search.keywordType,
            keyword: this.search.keyword,
            status: this.search.status,
            pageSize: this.pageSize,
            pageNo: this.pageNo
        };
        let res = await getUserList(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.tableData = res.data.data.list || [];
        this.pageNo = Number(res.data.data.pageNum);
        this.total = Number(res.data.data.total);
    }
    changePage(pageNo) {
        this.pageNo = pageNo;
        this.getList();
    }
    changePageSize(pageSize) {
        this.pageSize = pageSize;
        this.getList();
    }
    handleClickTabs(tabs) {
        this.search.type = tabs.name;
        this.search.courseId = '';
        this.onSearch();
    }
    onChangeType(val) {
        this.form.courseId = '';
    }
    onExport() {
        this.$confirm('是否确认导出？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let data = {
                type: this.search.type,
                courseId: this.search.type == 2 ? this.search.courseId[1] : this.search.courseId,
                keywordType: this.search.keywordType,
                keyword: this.search.keyword,
                status: this.search.status,
            };
            mixin_export('/courseAdmin/user/selfResearch/export', 'post', data);
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    onAdd() {
        this.$router.push({ path: '/student-manager/add' });
    }
    onDel(props) {
        this.$confirm('是否移除该学员', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            let data = {
                id: props.id,
                userId: props.userId,
                courseId: props.courseId
            };
            let res = await removeStudent(data);
            if (res.data.status !== 200)
                return this.$message.error(res.data.msg);
            this.$message({
                type: 'success',
                message: '已移除'
            });
            this.getList();
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    onChangeClass(props) {
        this.form.id = props.id;
        this.form.userId = props.userId;
        // this.form.courseId = props.courseId;
        this.form.courseName = props.courseName;
        this.form.type = props.courseType;
        this.isShowAdd = true;
    }
    handleClose() {
        this.isShowAdd = false;
        this.form.id = '';
        this.form.userId = '';
        this.form.courseId = '';
        this.form.courseName = '';
        this.form.type = '';
    }
    async onSubmit() {
        if (!this.form.courseId || this.form.courseId.length == 0) {
            return this.$message.error(`请选择${this.form.type == 2 ? '训练营/营期' : '专栏'}`);
        }
        let data = {
            id: this.form.id,
            userId: this.form.userId,
            courseId: this.form.type == 2 ? this.form.courseId[1] : this.form.courseId,
        };
        const res = await changeStudentCourse(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.$message({
            type: 'success',
            message: '调整成功'
        });
        this.handleClose();
        this.getList();
    }
    // 修正课程学习人数
    // Private method to handle course count updates
    handleCourseCountUpdate() {
        // Show confirmation dialog for updating course count
        this.$confirm(`是否修正学习人数`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(async () => {
            // Send a request to update the course count and receive the response
            const res = await updateCourseCount();
            // If the response status is not 200, return without showing success message
            if (res.data.status !== 200)
                return;
            // Show success message to the user
            this.$message.success("修正学习人数完成");
        });
    }
};
Login = tslib_1.__decorate([
    Component({
        filters: {
            formatJoinType(type) {
                //加入类型 1：订单生成；2：初始化导入；3：手动添加(导入)； 4：活动领取（兑换码）
                if (type == 1)
                    return '订单生成';
                if (type == 2)
                    return '初始化导入';
                if (type == 3)
                    return '手动添加(导入)';
                if (type == 4)
                    return '活动领取(兑换码)';
            }
        }
    })
], Login);
export default Login;
